var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu_mobile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 22",
    style: {
      enableBackground: "new 0 0 40 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.8,8.9c0,2-0.6,3.8-1.7,5.3l5.5,5.4c0.5,0.5,0.5,1.4,0,1.9c-0.5,0.5-1.4,0.5-2,0l-5.5-5.4c-1.5,1.1-3.3,1.7-5.3,1.7 c-5,0-9-4-9-8.9c0-4.9,4-8.9,9-8.9C31.8,0,35.8,4,35.8,8.9z M26.8,15.1c3.4,0,6.2-2.8,6.2-6.2c0-3.4-2.8-6.2-6.2-6.2 c-3.4,0-6.2,2.8-6.2,6.2C20.6,12.4,23.4,15.1,26.8,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,1.4H1.4C0.6,1.4,0,2,0,2.7c0,0.8,0.6,1.4,1.4,1.4h14.7C16.6,3.1,17.1,2.2,17.9,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1,9.6H1.4C0.6,9.6,0,10.2,0,11s0.6,1.4,1.4,1.4h14.2C15.3,11.5,15.1,10.6,15.1,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3,17.9H1.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4h20.3C21.6,20.6,20.4,19.7,19.3,17.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMobile);
export default __webpack_public_path__ + "static/media/menu_mobile.e7c6917f8eb662bb4d0a5b2858ae34c1.svg";
export { ForwardRef as ReactComponent };